import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {getIsMaintenanceEnabled} from '../../../api/UserManagementService';
import config from '../../../config';
import navConstants from '../../../constants/navConstants';
import {LeftPaneBrand} from './shared';
import {t} from 'i18next';
import {getLocalFormatedDate} from '../../../utils/utils';
import { Container, Grid } from '@mui/material';
import {ReactComponent as Blur} from '../../../assests/svg/login-bg-1.svg';
import {ReactComponent as Blur2} from '../../../assests/svg/login-bg-2.svg';

export const Unavailable = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const readStatus = async () => {
      const inMaintenanceMode = await getIsMaintenanceEnabled();
      
      if (cancelled) {
        return;
      }

      if (!inMaintenanceMode) {
        navigate(navConstants.auth.login, {replace: true});
        return;
      }
    };

    void readStatus();
    const interval = window.setInterval(readStatus, config.MAINTENANCE_STATUS_POLL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
    };
  }, [navigate]);

  return (
      <Box className="login-main-container" role="main">
        <Container maxWidth={false} className="login-page">
          <Blur
            className={`login-page_logo`}
            aria-hidden
          />
          <Blur2
            className={`login-page_logo2`}
            aria-hidden
          />
          <Grid container>
            <LeftPaneBrand />
            <Grid item xs={6} md={6}>
              <Box className="login-form">
                <div className="login-content">
                  <Typography
                      className="typo-text display2_size mist-color"
                      component="h1"
                    >
                      {t('auth.unavailable.heading')}
                    </Typography>
                    <Typography className="typo-text body1_size mist-color-900">
                      {t('auth.unavailable.body', {date: getLocalFormatedDate()})}
                    </Typography>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
};
